module.exports = __webpack_public_path__ + "8f2211ff9952045cf67d1696c2e6fa3b.svg"